module.exports = __webpack_public_path__ + "bg-home.jpg?d856a65bc856332d2a7ee14270c4fc36";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-home.jpg
// module id = 34
// module chunks = 0